import { render, staticRenderFns } from "./CompetitionEditInfo.vue?vue&type=template&id=1536bb58&scoped=true&"
import script from "./CompetitionEditInfo.vue?vue&type=script&lang=ts&"
export * from "./CompetitionEditInfo.vue?vue&type=script&lang=ts&"
import style0 from "./CompetitionEditInfo.vue?vue&type=style&index=0&id=1536bb58&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1536bb58",
  null
  
)

export default component.exports